module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpload),
      expression: "isUpload"
    }]
  }, [_c('div', {
    staticClass: "lenovobox_uploader_mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "lenovobox_uploader"
  }, [_c('div', [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "id": "lenovobox_upload_btn",
      "size": "1"
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.upload_progress_text",
      value: ([_vm.current, _vm.total]),
      expression: "[current,total]",
      modifiers: {
        "upload_progress_text": true
      }
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "lenovobox_uploader_filename"
  }, [_vm._v(_vm._s(_vm.currentUploadFilename))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loading",
    style: ('width:' + _vm.progress + '%')
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f2a7bc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/uploader.vue
// module id = 218
// module chunks = 3